import React from "react";
import { useTranslation } from "react-i18next";
import RegistrationForm from "../Components/Complaints/ComplaintsForm";
import "../Components/Complaints.css";

export default function RegistrationPage() {
  const { t } = useTranslation(); // <-- ADDED

  return (
    <div className="regPage-wrapper">
      <div className="regPage-container">

        {/* TITLE */}
        <h1 className="regPage-title">
          {t("registration.title")}
        </h1>

        {/* SUBTITLE */}
        <p className="regPage-subtitle">
          {t("registration.subtitle")}
        </p>

        <RegistrationForm />
      </div>
    </div>
  );
}
